/**
 * Este módulo contém as ações que fazem as primeiras requisições.
 * Obrigatoriamente elas devem ser as primeiras requisições feitas
 * à API, pois buscam as configurações, dados de perfil e o `token`
 * de sessão.
 *
 * @module core/session/handshake/actions
 */
import { List, Map } from 'immutable';

import { Header, Request, Response } from '../../comm';
import comm from '../../comm/actions';
import sessions from '../actions';
import { getToken } from '../token-storage';

import { views as contractViews } from '../../../applets/contratos/core';

const SESSION_VIEW = '/suaformatura/coruja/core/session/init/view';

/**
 * TODO: Mostrar uma tela de falhar no login quando essa rota falhar.
 *
 * Busca os dados de sessão, perfil do usuário e configuração
 * do sistema e salvo-os no Redux.
 *
 * [Thunk*](https://github.com/reduxjs/redux-thunk).
 *
 * @returns {Function} um nova ação assíncrona (thunk*).
 */
function init(pushURL = null, force = false) {
  const token = getToken();
  return comm.get(
    Request({
      view: SESSION_VIEW,
      force,
      url: '/v1/all/usuario_conf',
      header: Header({
        token,
        include: List(['perfil']),
      }),
      onSuccess: Response({
        dismiss: true,
        dispatch: List([
          sessions.setUserProfile,
          // Quando o backend marca `indAssinarContrato=true` no /usuario_conf,
          // redireciona o usuário direto pra tela de assinatura. É o que liga
          // o fluxo do participe (cadastro+confirmação) à assinatura final do
          // contrato. Estava comentado e por isso o botão "Assinar contrato"
          // não disparava o redirect automático ao logar.
          (data) => {
            if (pushURL && data && data.get('indAssinarContrato')) {
              pushURL(contractViews.signature);
            }
          },
        ]),
        transform: (data) => data && data.first(),
      }),
    }),
  );
}

/**
 * Busca os dados de configuração pública do sistema e
 * salvo-os no Redux.
 *
 * [Thunk*](https://github.com/reduxjs/redux-thunk).
 *
 * @returns {Function} um nova ação assíncrona (thunk*).
 */
function initPublic() {
  return comm.get(
    Request({
      view: SESSION_VIEW,
      url: '/v1/pub/configs',
      onSuccess: Response({
        dismiss: true,
        dispatch: sessions.setUserProfile,
        transform: (data) => data && Map({ parametros: data.first() }),
      }),
    }),
  );
}

const actions = {
  initPublic,
  init,
};

export default actions;
